<div class="content-block light-control-host">
  <h1>Let's get connected</h1>

  <div class="margin-top">
    To replicate your primary environment to your recovery region, {{ uiService.productName }} needs limited access to
    your AWS accounts.
  </div>

  <div class="question margin-top">
    <strong>How would you like to manage access permissions?</strong>
  </div>

  <div class="access-method-cards margin-top">
    <!-- CloudFormation Templates Card -->
    <div
      class="access-method-card light-content-panel"
      [class.selected]="selectedMethod === 'cloudformation'"
      (click)="selectMethod('cloudformation')"
    >
      <!-- The label is the click target and the radio's accessible name, so the whole
      card works by mouse and by keyboard without a custom role. -->
      <label class="card-header">
        <input
          type="radio"
          name="accessMethod"
          value="cloudformation"
          class="arpio-radio"
          [checked]="selectedMethod === 'cloudformation'"
          (change)="selectMethod('cloudformation')"
        />
        <h3>CloudFormation Templates</h3>
      </label>
      <div class="card-description">
        Deploy access templates individually to each AWS account. Best for simple setups or accounts outside an AWS
        Organization.
      </div>
      <div class="card-features">
        <div class="feature"><svg lucideCheck></svg> Works with any AWS account</div>
        <div class="feature"><svg lucideCheck></svg> No Organization required</div>
      </div>
    </div>

    <!-- AWS StackSets Card -->
    <div
      class="access-method-card light-content-panel"
      [class.selected]="selectedMethod === 'stacksets'"
      (click)="selectMethod('stacksets')"
    >
      <!-- The label is the click target and the radio's accessible name, so the whole
      card works by mouse and by keyboard without a custom role. -->
      <label class="card-header">
        <input
          type="radio"
          name="accessMethod"
          value="stacksets"
          class="arpio-radio"
          [checked]="selectedMethod === 'stacksets'"
          (change)="selectMethod('stacksets')"
        />
        <h3>AWS StackSets</h3>
      </label>
      <div class="card-description">
        Deploy once from your management account and automatically fan out to member accounts. Best for multi-account
        Organizations.
      </div>
      <div class="card-features">
        <div class="feature"><svg lucideCheck></svg> Centralized management</div>
        <div class="feature"><svg lucideCheck></svg> Auto-deploy to new accounts</div>
      </div>
    </div>
  </div>

  <!-- Navigation Buttons -->
  <div class="flex-center-row margin-top">
    <div class="spacer"></div>
    <button type="button" class="arpio-secondary-button" (click)="backButtonClick()">Back</button>
    <button type="button" class="arpio-button margin-left" (click)="continueButtonClick()">
      Continue with {{ selectedMethodLabel }}
    </button>
  </div>
</div>
